import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

export const FlexArticle = styled.article`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 38px;
  text-align: center;
`;

export const WidenText = styled.p`
  ${font.sm};
  ${stacked._1x}
  color: ${colors['$hpx-grey-600']};
`;

export const WidenSearchButton = styled(ButtonBase)`
  ${font.sm};
  height: 37px;
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  padding: 0 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
  display: inline-flex;
  align-items: center;
  margin: auto;
  cursor: pointer;
`;

export const BoldText = styled.b`
  padding-left: 4px;
`;

export const NoListingsIcon = styled.img`
  ${stacked._3x};
  width: 100px;
  height: 100px;

  @media (min-width: 768px) {
    width: 134px;
    height: 134px;
  }
`;
export const NoListingsFoundText = styled.p`
  ${font.md};
  color: ${colors['$hpx-grey-600']};
  text-align: center;
`;

export const AlertArticle = styled.article`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 8px;
`;

export const AlertText = styled.p`
  ${stacked._1x};
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  text-align: center;
`;

export const NearbyAreaContainer = styled.div`
  /* Remove horizontal padding on mobile since viewport already has padding */
  padding-left: 0;
  padding-right: 0;

  /* Add horizontal padding back on desktop (md breakpoint and up) */
  @media (min-width: 768px) {
    padding-left: 16px;
    padding-right: 16px;
  }
`;
